import React from "react";
const GoogleDriveAttachmentIcon = React.forwardRef((props, svgRef) => (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 40 40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlinkHref="http://www.w3.org/1999/xlink"
    ref={svgRef}
    {...props}
  >
    <title>drive</title>
    <g
      id="drive"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g transform="translate(1.000000, 3.000000)">
        <path
          d="M6.69148289,34 L18.9243668,12.0635463 C18.9243668,12.0635463 15.4074958,5.59693573 13.5891659,2.38133213 C13.3488107,1.95627876 13.0095583,1.26384766 12.6994171,0.765662188 C12.4393286,0.347877401 12.2727381,0.0155064771 12.2727381,0.0155064771 C12.2727381,0.0155064771 12.2346045,-0.0193830964 12.2153775,0.0155064771 C8.14369176,7.40402891 0,22.2857425 0,22.2857425 L6.69148289,34 Z"
          id="path-1"
          fill="#009B58"
        ></path>
        <polygon
          id="path-3"
          fill="#2872F1"
          points="6.70068449 33.9829661 30.979626 33.9829661 37.9839803 22.3938504 13.1850119 22.3671721"
        ></polygon>
        <polygon
          id="path-5"
          fill="#FCCD38"
          points="12.2726779 1.84627424e-10 25.7323889 1.84627424e-10 38 22.3902949 24.5972833 22.3902949"
        ></polygon>
      </g>
    </g>
  </svg>
));
GoogleDriveAttachmentIcon.displayName = "GoogleDriveAttachmentIcon";
export default GoogleDriveAttachmentIcon;
